import React, { Component } from 'react';
import * as artData from './../../../data/art_data.json';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { NEXT_PUBLIC_GOOGLE_MAPS_API_KEY } from '../../../helpers/urlBase';
import ArtInfoModal from './modal-map/ArtInfoModal';

const DEPAUW_BOUNDS = {
  north: 39.653244,
  south: 39.621949,
  west: -86.902833,
  east: -86.831743,
};

const ClickLog = new Array(31).fill(0);

const DEPAUW_CENTER = { lat: 39.63930503475011, lng: -86.86344078645712 };

const mapStyle = { width: '100vw', height: '100vh' };

const option = {
    isMarkerShown: true,
//   restriction: {
//     latLngBounds: DEPAUW_BOUNDS,
//     strictBounds: false,
//   },

//   mapTypeControl: false,
//   scaleControl: true,
//   streetViewControl: false,
//   fullscreenControl: false,
//   clickableIcons: false,
};


class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedArt: null,
      modalShow: false,
      userPosition: {
        latitude: null,
        longitude: null,
      },
    };
  }

  componentDidMount() {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition((position) => {
        this.setState({
          userPosition: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          },
        });
        console.log('Latitude is :', position.coords.latitude);
        console.log('Longitude is :', position.coords.longitude);
      });
    }
  }

  setSelectedArt = (art) => {
    this.setState({
      selectedArt: art,
    });
    ClickLog[art.properties.ART_ID] += 1;
    console.log(ClickLog[art.properties.ART_ID]);
  };

  setModalShow = (show) => {
    this.setState({
      modalShow: show,
    });
  };

  render() {
    return (
      <div>
        <LoadScript googleMapsApiKey={ NEXT_PUBLIC_GOOGLE_MAPS_API_KEY }>
          <GoogleMap
            mapContainerStyle={mapStyle}
            center={ {
                lat: this.state.userPosition.latitude,
                lng: this.state.userPosition.longitude,
              } }
            zoom={16}
            options={option}
          >
            <Marker
              key={'userMarker'}
              position={{
                lat: this.state.userPosition.latitude,
                lng: this.state.userPosition.longitude,
              }}
              icon={{
                url: './assets/images/user.png',
                scaledSize: {
                  width: 40,
                  height: 40,
                },
              }}
            />

            {artData.features.map((artWork) => (
              <Marker
                key={artWork.properties.ART_ID}
                position={{
                  lat: artWork.geometry.coordinates[0],
                  lng: artWork.geometry.coordinates[1],
                }}
                onClick={() => {
                  this.setSelectedArt(artWork);
                  this.setModalShow(true);
                }}
                icon={{
                  url: './assets/images/marker.png',
                  scaledSize: {
                    width: 40,
                    height: 40,
                  },
                }}
              />
            ))}
          </GoogleMap>
        </LoadScript>

        {/* <ArtInfoModal
          show={this.state.modalShow}
          onHide={() => this.setModalShow(false)}
          selectedArt={this.state.selectedArt}
        /> */}
      </div>
    );
  }
}

export default MapContainer;
